export default __webpack_public_path__ + "assets/images/double_belt_cooler_d051d592451cbe7d64aa6fa0cf26ffb4.jpg";